import { LogsService } from '../api-log/services/LogsService';
import { LogRequest } from '../api-log/models/LogRequest';

import { useLoggerContext } from './LoggerContext';

import { defaultSession, useSession } from '../SessionContext';

export class Logger {
    logLevel: string;
    session = useSession().session;
    user_email : string;
    constructor(logLevel: string) {
        this.logLevel = logLevel;
        this.session = useSession().session;
        this.user_email = this.session?.user?.email ?? 'unknown user';
    }
    log(message: string, ...optionalParams: any[]) {
        this.user_email = this.session?.user?.email ?? 'unknown user';
        console.log(`%c${message}`, 'color: #877bd2; font-weight: bold;', ...optionalParams);
        if (this.logLevel === 'debug') {            
            const lr: LogRequest = { user: this.user_email, message: message,  dttm: new Date().toISOString() };
            LogsService.postLogDebug(lr);
        }
    }
    info(message: string, ...optionalParams: any[]) {
        this.user_email = this.session?.user?.email ?? 'unknown user';
        if (optionalParams.length > 0) {
            //console.table(optionalParams);                        
                console.info(`%c${message}`, 'color: #78ba8c; font-weight: bold;', ...optionalParams);            
            //console.info(`%c${umsg}`, 'color: #78ba8c; font-weight: bold;', ...optionalParams);
        }
        else{
            console.info(`%c${message}`, 'color: #78ba8c; font-weight: bold;', ...optionalParams);
        }
        if (this.logLevel === 'info' || this.logLevel === 'debug') {            
            const lr: LogRequest = { user: this.user_email, message: message,  dttm: new Date().toISOString() };
            LogsService.postLogInfo(lr);
        }
    }
    warn(message: string, ...optionalParams: any[]) {
        this.user_email = this.session?.user?.email ?? 'unknown user';
        if (this.logLevel === 'warn' || this.logLevel === 'info' || this.logLevel === 'debug') {
            if (optionalParams.length > 0) {
                //console.table(optionalParams);
                console.warn(`%c${message}`, 'color: #FFA500; font-weight: bold;', ...optionalParams);
            } else {
                console.warn(`%c${message}`, 'color: #FFA500; font-weight: bold;', ...optionalParams);
            }
            const lr: LogRequest = { user: this.user_email, message: message,  dttm: new Date().toISOString() };
            LogsService.postLogWarn(lr);
        }
    }
    error(message: string, ...optionalParams: any[]) {
        this.user_email = this.session?.user?.email ?? 'unknown user';
        console.error(`%c${message}`, 'color: #FF0000; font-weight: bold;', ...optionalParams);
        if (this.logLevel === 'error' || this.logLevel === 'warn' || this.logLevel === 'info' || this.logLevel === 'debug') {            
            const lr: LogRequest = { user: this.user_email, message: message,  dttm: new Date().toISOString() };
            LogsService.postLogError(lr);
        }
    }
    debug(message: string, ...optionalParams: any[]) {
        this.user_email = this.session?.user?.email ?? 'unknown user';
        if (optionalParams.length > 0) {
            // const json_obj = optionalParams[0];
            // const keys = Object.keys(json_obj);
            console.debug(`%c${message}`, 'color: #dd19ac; font-weight: bold;', ...optionalParams);
            //console.table(optionalParams);
        }
        else{
            console.debug(`%c${message}`, 'color: #dd19ac; font-weight: bold;', ...optionalParams);
        }
        if (this.logLevel === 'debug') {            
            const lr: LogRequest = { user: this.user_email, message: message,  dttm: new Date().toISOString() };
            LogsService.postLogDebug(lr);
        }
    }
}

export function useLogger() {
    const { logLevel } = useLoggerContext();
    return new Logger(logLevel);
}